module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "person-consultant"
  }, [_c('div', {
    staticClass: "person-wrapper"
  }, [_c('div', {
    staticClass: "person-picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.counselorInfo.logoUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "person-content"
  }, [_c('h2', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.counselorInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "job"
  }, [_vm._v(_vm._s(_vm.counselorInfo.profession))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('p', {
    staticClass: "adept"
  }, [_vm._v("擅长：" + _vm._s([].concat(_vm.counselorInfo.skills).join(' | ')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "person-contact"
  }, [_c('div', {
    staticClass: "appointment pull-left",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onclick($event)
      }
    }
  }, [_c('span', [_vm._v("预约贷款服务")])]), _vm._v(" "), _c('ul', {
    staticClass: "pull-left"
  }, [_c('li', {
    staticClass: "pull-left"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.counselorInfo.phone))])]), _vm._v(" "), _c('li', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('span', {
    staticClass: "wechat"
  }, [_vm._v(_vm._s(_vm.counselorInfo.wechat))])]), _vm._v(" "), _c('li', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _c('span', {
    staticClass: "qq"
  }, [_vm._v(_vm._s(_vm.counselorInfo.qq))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ba317ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/person.vue
// module id = 355
// module chunks = 1